import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Category, Menu } from '../../(routes)/online-ordering/types';

export interface DealState {
  dealItemsSelection: [] | null | any;
  isDeals: boolean;
  selectedBuyDealMenu: Menu | null;
  selectedGetDealMenu: Menu | null;
  selectedBuyDealCategory: Category | null;
  selectedGetDealCategory: Category | null;
  isDealUnavailable: boolean;
}

const initialState: DealState = {
  dealItemsSelection: [],
  isDeals: false,
  selectedBuyDealMenu: null,
  selectedGetDealMenu: null,
  selectedBuyDealCategory: null,
  selectedGetDealCategory: null,
  isDealUnavailable: false,
};

export const dealSlice = createSlice({
  name: 'deal',
  initialState,
  reducers: {
    setDealItemsSelection: (state, action: PayloadAction<any>) => {
      state.dealItemsSelection = [...action.payload.dealItemsSelection];
    },
    removeDealItemsSelection: (state) => {
      state.dealItemsSelection = [];
    },
    updateDealSettings: (state, action: PayloadAction<any>) => {
      for (const key in action?.payload) {
        (state as any)[key] = action?.payload[key];
      }
    },
    setSelectedBuyDealMenu: (state, action: PayloadAction<any>) => {
      state.selectedBuyDealMenu = action.payload.menu;
    },
    setSelectedGetDealMenu: (state, action: PayloadAction<any>) => {
      state.selectedGetDealMenu = action.payload.menu;
    },
    setSelectedBuyDealCategory: (state, action: PayloadAction<any>) => {
      state.selectedBuyDealCategory = action.payload;
    },
    setSelectedGetDealCategory: (state, action: PayloadAction<any>) => {
      state.selectedGetDealCategory = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDealItemsSelection,
  removeDealItemsSelection,
  updateDealSettings,
  setSelectedBuyDealMenu,
  setSelectedGetDealMenu,
  setSelectedBuyDealCategory,
  setSelectedGetDealCategory,
} = dealSlice.actions;

export default dealSlice.reducer;
